import script from "./caseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./caseDetail.vue?vue&type=script&setup=true&lang=js"

import "./caseDetail.vue?vue&type=style&index=0&id=0a132383&lang=scss&scoped=true"
import "./caseDetail.vue?vue&type=style&index=1&id=0a132383&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a132383"]])

export default __exports__